import * as Yup from "yup";
import { Strings } from "@app/constants";

export const yourDetailsSchema = Yup.object()
  .shape({
    name: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.firstName)
    ),
    phoneNumber: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.phone)
    ),
    address: Yup.string().required(Strings.validation.fieldRequired("address")),
    townOrCity: Yup.string().required(
      Strings.validation.fieldRequired("town or city")
    ),
    termAndCondition: Yup.boolean()
      .transform(
        (value, originalValue) =>
          originalValue === "true" || originalValue === true
      )
      .oneOf([true], Strings.validation.selectionRequired("above confirmation"))
      .required(Strings.validation.selectionRequired("above confirmation")),
  })
  .required();
